import { render, staticRenderFns } from "./Miraverse.vue?vue&type=template&id=3b58f932&scoped=true"
import script from "./Miraverse.vue?vue&type=script&lang=js"
export * from "./Miraverse.vue?vue&type=script&lang=js"
import style0 from "./Miraverse.vue?vue&type=style&index=0&id=3b58f932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58f932",
  null
  
)

export default component.exports